import { useContext, useEffect, useState } from 'react';
import { Heading } from '../../../../ui/components/Heading/Heading';
import { InitialContext } from '../../../Layout/Layout';
import styles from './AppointmentsHistory.module.scss';
import {
  AppointmentsGroupedByDay,
  AppointmentsGroupedByDayResponse,
} from '../../../../gql/graphql';
import { GET_ALL_APPOINTMENTS_GROUPED_BY_DAY } from '../../../../graphql/Appointments';
import { useGQLLazyQuery } from '../../../../ui/utils/graphql';
import { AppointmentsGroupedByDayView } from './components/AppointmentsGroupedByDay/AppointmentsGroupedByDay';
import { Button } from '../../../../ui/components/Button';

export const AppointmentsHistory = () => {
  const { company } = useContext(InitialContext);
  const [page, setPage] = useState(1);
  const [appointments, setAppointments] = useState<AppointmentsGroupedByDay[]>(
    []
  );
  const { lazy } = useGQLLazyQuery<
    AppointmentsGroupedByDayResponse,
    { companyId: string; page: number; limit: number }
  >(GET_ALL_APPOINTMENTS_GROUPED_BY_DAY, {
    onCompleted: (data) => {
      console.log(`DATA: ${data}`);

      setAppointments((prev) => {
        const newAppointments = data;
        if (page === 1) return newAppointments.groups || [];
        if (prev?.[prev.length - 1].day === newAppointments.groups?.[0]?.day) {
          const newPrev: AppointmentsGroupedByDay[] = [
            ...prev.slice(0, prev.length - 1),
            {
              ...prev[prev.length - 1],
              appointments: [
                ...prev[prev.length - 1].appointments,
                ...(newAppointments?.groups?.[0].appointments || []),
              ],
            },
            ...(newAppointments.groups || []).slice(1),
          ];
          return newPrev;
        }
        return [...prev, ...(newAppointments.groups || [])];
      });
    },
    onError: (error) => {},
  });

  useEffect(() => {
    if (company?.id) {
      lazy({
        variables: {
          companyId: company?.id,
          page,
          limit: 10,
        },
        fetchPolicy: 'network-only',
      });
    }
  }, [company, page]);

  const renderAppointmentsGroupedByDay = () => {
    if (!appointments) return null;
    return appointments.map((day) => (
      <AppointmentsGroupedByDayView
        key={`${day.day}-${day?.appointments?.length}`}
        {...day}
      />
    ));
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Heading className={styles.heading} headingLevel="h1">
          {`${company?.name} - Historial de citas`}
        </Heading>
      </div>
      <p className={styles.description}>
        Esta página muestra el historial de tus citas. Aquí podrás encontrar un
        registro de todas las citas que has tenido.
      </p>
      <div className={styles.container}>{renderAppointmentsGroupedByDay()}</div>
      <Button
        className={styles['load-more']}
        onClick={() => {
          setPage((p) => p + 1);
        }}
      >
        Ver más
      </Button>
    </div>
  );
};
